import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SnFormatSelectComponent from "./snFormatSelect.component";
import { selectLoading } from "../../../../notification";
import { getSnFormatsByBranch } from "../../../redux";

export default function SnFormatSelectContainer({
  selectedBranch,
  selectedFormat,
  handleSelect,
}) {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const snFormats = useSelector((state) => state.companies.snFormats.list);
  const isFetching = useSelector((state) =>
    selectLoading(state, getSnFormatsByBranch.typePrefix)
  );
  const isError = useSelector((state) => state.companies.snFormats.isError);

  useEffect(() => {
    if (selectedBranch) {
      dispatch(getSnFormatsByBranch(selectedBranch.node_id));
    }
  }, [selectedBranch]);

  const handleOpen = (event) => {
    if (isFetching) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleBatchSelect = (batch) => {
    handleSelect(batch);
    handleClose();
  };

  return (
    <>
      <SnFormatSelectComponent
        open={open}
        handleClick={handleOpen}
        isBranchSelected={!!selectedBranch}
        selectedFormat={selectedFormat}
        handleSelect={handleBatchSelect}
        isFetching={isFetching}
        isError={isError}
        snFormats={snFormats}
      />
    </>
  );
}
